import { Container, Graphics } from '@pixi/react'
import { Graphics as PixiGraphics } from 'pixi.js'
import { useState } from 'react'

// Pixi icon button using Graphics
function PixiIconButton({ x = 0, y = 0, size = 48, radius = 6, type = 'plus', onClick }: {
  x?: number
  y?: number
  size?: number
  radius?: number
  type: 'plus' | 'minus'
  onClick?: () => void
}) {
  const lineThickness = Math.max(2, Math.round(size * 0.08))
  const half = size / 2
  const symbolLen = size * 0.36 // length of the + or - bar
  const [isHovered, setIsHovered] = useState(false)

  const draw = (g: PixiGraphics) => {
    g.clear()
    // background: semi-transparent gray
    g.beginFill(0x666666, isHovered ? 0.8 : 0.6)
    g.drawRoundedRect(x, y, size, size, radius)
    g.endFill()

    // draw symbol (semi-transparent white)
    g.lineStyle(lineThickness, 0xffffff, 0.9)

    // center coordinates
    const cx = x + half
    const cy = y + half
    const halfSym = symbolLen / 2

    // horizontal bar (present in both + and -)
    g.moveTo(cx - halfSym, cy)
    g.lineTo(cx + halfSym, cy)

    // vertical bar (only for plus)
    if (type === 'plus') {
      g.moveTo(cx, cy - halfSym)
      g.lineTo(cx, cy + halfSym)
    }
  }

  return (
    <Graphics
      draw={draw}
      eventMode="static"
      pointerdown={() => onClick?.()}
      pointerover={() => {
        setIsHovered(true)
      }}
      pointerout={() => {
        setIsHovered(false)
      }}
    />
  )
}

// A small wrapper to place two buttons side-by-side
export default function OPBetDetailScaleButtons({
  x = 0,
  y = 0,
  size = 32,
  gap = 8,
  radius = 6,
  onPlus,
  onMinus,
}: {
  x?: number
  y?: number
  size?: number
  gap?: number
  radius?: number
  onPlus?: () => void
  onMinus?: () => void
}) {
  return (
    <Container x={x} y={y} name="bet detail scale buttons">
      <PixiIconButton x={0} y={0} size={size} radius={radius} type="minus" onClick={() => onMinus?.()} />
      <PixiIconButton x={size + gap} y={0} size={size} radius={radius} type="plus" onClick={() => onPlus?.()} />
    </Container>
  )
}
